import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";
import {useParams} from "react-router-dom";
import ImageGallery from "react-image-gallery";

export default () => {
    let title = "Туроператоры, турагентства Tour Operators, Travel Agencies";

    const itemsData = [
        {
            id: 1,
            location: 'Брест',
            name: 'Генеральное консульство РОССИЙСКОЙ ФЕДЕРАЦИИ в г. Бресте',
            adress: 'адрес: 224030 г. Брест, ул. Пушкинская, 10',
            phones: [
                '(+375) 162 23-78-42',
                '(+375) 162 21-04-73 (факс)',
            ],
        },
        {
            id: 2,
            location: 'Брест',
            name: 'Генеральное консульство РЕСПУБЛИКИ ПОЛЬША в г. Бресте',
            adress: '224016 г. Брест, ул. Куйбышева, 34',
            phones: [
                '(+375) 162 27-00-00',
                '(+375) 162 23-60-28 (факс)',
            ],
        },
        {
            id: 3,
            location: 'Брест',
            name: 'Консульство УКРАИНЫ в г. Бресте',
            adress: '224005 г. Брест, ул. Пушкинская, 16/1',
            phones: [
                '(+375) 162 22-04-55',
                '(+375) 162 22-03-88 (факс)',
            ],
        },
    ];

    let get_all_list = (data) => {
        return (
            <ul>
                {data?.map((h) => {
                    const link = "/reference-information-consulates/" + h.id;
                    return (<li><a href={link}>{h.location}. {h.name}</a></li>)
                })}

            </ul>
        );
    }

    let get_item = (data) => {
        let result = null;

        if (data.name != undefined) {
            title = data.name;
        }

        let gal = [];
        if (data.gal != undefined) {
            data.gal.map(item => {
                gal.push({
                    original: item.src,
                    thumbnail: item.src,
                    description: item.alt,
                });
            });
        }

        return (
            <>
                {data.adress != undefined && <p>{data.adress}</p>}
                {data.phones != undefined && <ul>{data.phones.map(p => <li>{p}</li>)}</ul>}
                {data.url != undefined && <a href={data.url}>{data.url}</a>}
                {data.email != undefined && <p>Email: <span>{data.email}</span></p>}
                {gal?.length > 0 &&
                    <div className="two-col-cell">
                        <ImageGallery
                            items={gal}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                }
                {data?.desc?.length > 0 &&
                    data.desc.map(d => <p>{d}</p>)
                }
                {data?.imgs?.length > 0 &&
                    data.imgs.map(i => <img src={i}/>)
                }
            </>
        );
    }

    const params = useParams();

    let view = undefined;
    let nav = get_all_list(itemsData);
    if (params.id != undefined) {
        const id = itemsData.findIndex(e => e.id == params.id);
        if (id == -1) {
            view = get_all_list(itemsData);
        } else {
            view = get_item(itemsData[id]);
        }
    }

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    {view}
                </div>
                <div className="pageitem">
                    <hr/>
                    {nav}
                </div>
            </div>
        </>
    );
}